import React, { Component, Fragment } from 'react';
import RcViewer from '@hanyk/rc-viewer';

class ImageViewer extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { fileList, src } = this.props;
    const toolbarHide = {
      show: true,
    };
    const toobbarShow = {
      show: true,
      size: 'large',
    };
    const options = {
      title: false, //图片名称
      navbar: false, //缩略图
      fullscreen: false, //全屏播放
      loop: false, //是否循环 上一个 下一个
      loading: false,
      button: true, //
      tooltip: true, //缩放百分比
      movable: true, //图片移动
      toolbar: {
        zoomIn: toobbarShow, //放大
        zoomOut: toobbarShow, //缩小
        oneToOne: toolbarHide, //自适应
        reset: toobbarShow, //重置
        prev: toolbarHide, //上一张
        // play: toolbarHide, //播放
        next: toolbarHide, //下一张
        rotateLeft: toolbarHide, //左旋转
        rotateRight: toolbarHide, //右旋转
        flipHorizontal: toolbarHide, //左右翻转
        flipVertical: toolbarHide, //上下翻转
      },
    };
    return (
      <Fragment>
        <RcViewer options={options}>
          {fileList.map((item, index) => (
            <img
              width={100}
              height={100}
              src={item[src]}
              style={{ marginRight: 10 }}
              key={item[src]}
            />
          ))}
        </RcViewer>
      </Fragment>
    );
  }
}

export default ImageViewer;
